module.exports = __webpack_public_path__ + "assets/images/entertainment_phase4.0b7f15970334c3976557bc90f72a1194.svg";